import React from 'react';
import {Controller} from 'react-hook-form';
import {Slider} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Translate} from '../../../config/TranslationProvider';

const useStyles = makeStyles(() => ({
    root: {
        color: '#272b41'
    }
}));

const Price = ({control, selected}) => {
    const classes = useStyles();

    return (
        <div className="form-group p-bottom-10">
            <div className="price-range rs-primary">
                <Controller
                    name="price_amount_to"
                    control={control}
                    defaultValue={selected}
                    render={({value, onChange, ...props}) =>
                        <>
                            <label className="d-flex justify-content-between" htmlFor="price_amount_to">
                                <span>
                                    <Translate value="price_max" />
                                    {(value || value === 0) && <>{value} &nbsp;€</>}
                                    {!value && value !== 0 && '-'}
                                </span>
                            </label>
                            <div className="slider-range">
                                <Slider
                                    {...props}
                                    value={value || value === 0 ? value : 100}
                                    onChange={(_, value) => {
                                        if (value === 100) {
                                            value = null;
                                        }

                                        onChange(value);
                                    }}
                                    className={classes.root}
                                    min={0}
                                    max={100}
                                    step={1}
                                />
                            </div>
                        </>
                    }
                />
            </div>
        </div>
    );
};


export default Price;
